import { QueryType } from "../models";
import { useShippingMethodQuery } from "../queries";

export const useShippingMethodSelectOptions = () => {
    const {
        listQuery: { data },
    } = useShippingMethodQuery({ queryType: QueryType.List });
    return data?.map((method) => ({ label: method.name, value: method.id })) ?? [];
};